import "./wdyr"; // <-- first import
import React from 'react';
import App from './src';


import { createRoot } from 'react-dom/client';
const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<App />);
if (module.hot) module.hot.accept('./src', () => root.render(<App />))
